import { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import {
  AssemblyHeaderRow,
  MaterialHeaderRow,
  RoutingHeaderRow,
} from 'model/Project/BoMItemRow'
import { ProjectViews } from 'store/UI/UITypes'
import { ProjectState } from '../../../../store/Project/ProjectTypes'

export const setBoMItemOpen: CaseReducer<
  ProjectState,
  PayloadAction<{
    bomItemId: string
    isOpen: boolean
    preferTreeView?: boolean
    disableOpenParents?: boolean
  }>
> = (state, action) => {
  const bomItem = action.payload.preferTreeView
    ? state.treeView[action.payload.bomItemId] ||
      state.flatView[action.payload.bomItemId]
    : state.flatView[action.payload.bomItemId] ||
      state.treeView[action.payload.bomItemId]

  if (!bomItem) {
    return
  }

  if (bomItem.type === 'Row') {
    // open all headers where this row is a child
    // AssemblyHeader
    const assembly = (state.flatView[bomItem.parentId] ||
      state.treeView[bomItem.parentId]) as AssemblyHeaderRow
    assembly.isOpen = action.payload.isOpen

    // material header
    const materialHeaderId = state.materialHeadersIds.find((x) => {
      return (state.flatView[x] as MaterialHeaderRow).partTypeIds.includes(
        bomItem.id
      )
    })
    if (materialHeaderId) {
      const materialHeader = state.flatView[
        materialHeaderId
      ] as MaterialHeaderRow
      materialHeader.isOpen = action.payload.isOpen
    }

    // Routes Header
    const routeId = state.routingHeadersIds.find((x) => {
      return (state.flatView[x] as RoutingHeaderRow).partTypeIds.includes(
        bomItem.id
      )
    })

    if (routeId) {
      const routeHeader = state.flatView[routeId] as RoutingHeaderRow
      routeHeader.isOpen = action.payload.isOpen
    }
  } else if (
    bomItem.type === 'Assembly' &&
    !action.payload.disableOpenParents
  ) {
    // open all parent headers
    let parentId = bomItem.parentId

    // open it self
    bomItem.isOpen = action.payload.isOpen

    // open parent assemblies if it exists
    while (
      !parentId ||
      parentId !== state.activeProject?.id ||
      parentId !== action.payload.bomItemId
    ) {
      const parent = (state.treeView[parentId] ||
        state.flatView[parentId]) as AssemblyHeaderRow

      if (!parent) {
        break
      }

      parent.isOpen = action.payload.isOpen
      parentId = parent.parentId
    }
  } else {
    bomItem.isOpen = action.payload.isOpen
  }
  return
}

export const openOrCloseAllHeaders: CaseReducer<
  ProjectState,
  PayloadAction<boolean>
> = (state, action) => {
  switch (state.currentView) {
    case ProjectViews.SalesView:
    case ProjectViews.DashboardView: {
      state.assemblyHeadersIds.forEach((headerId) =>
        setBoMItemOpen(state, {
          payload: {
            bomItemId: headerId,
            isOpen: action.payload,
          },
          type: 'setBomItemOpen',
        })
      )
      break
    }
    case ProjectViews.AssemblyHierarchy:
      state.assemblyStructuresIds.forEach((headerId) =>
        setBoMItemOpen(state, {
          payload: {
            bomItemId: headerId,
            isOpen: action.payload,
            preferTreeView: true,
          },
          type: 'setBomItemOpen',
        })
      )
      break
    case ProjectViews.PurchaseView:
      state.materialHeadersIds.forEach((headerId) =>
        setBoMItemOpen(state, {
          payload: {
            bomItemId: headerId,
            isOpen: action.payload,
            preferTreeView: false,
          },
          type: 'setBomItemOpen',
        })
      )
      break
    case ProjectViews.RoutesView:
      state.routingHeadersIds.forEach((headerId) =>
        setBoMItemOpen(state, {
          payload: {
            bomItemId: headerId,
            isOpen: action.payload,
            preferTreeView: false,
          },
          type: 'setBomItemOpen',
        })
      )
      break
    default:
      break
  }
}
